import "Components/ConfigLayout/System/ScheduleSettings/SchedulePopover/SchedulePopover.less";
import { Button, Checkbox, Icon, IconSize, Popover, PopoverTrigger } from "@clintonelec/react-storybook";
import type { ScheduledDay, ScheduleDays } from "Interfaces";
import { type ChangeEvent, memo } from "react";
import type { ScheduleType } from "Data/Objects/System";

type SchedulePopoverProps = {
	checkScheduledDay: (id: number) => (value: ScheduledDay) => void;
	days: string[];
	index: number;
	scheduledDay: ScheduledDay;
	scheduleType: ScheduleType;
	changeCheckbox: (day: string, id: number) => (event: ChangeEvent<HTMLInputElement>) => void;
};

function SchedulePopover(props: SchedulePopoverProps) {
	const {
		checkScheduledDay, days, index, scheduledDay, scheduleType, changeCheckbox: handleCheckboxChange
	} = props;

	const handleAllDayClick = (all: boolean) => () => {
		checkScheduledDay(index)({
			MON: all,
			TUE: all,
			WED: all,
			THU: all,
			FRI: all,
			SAT: all,
			SUN: all
		});
	};

	const handleWeekdayClick = (all: boolean) => () => {
		checkScheduledDay(index)({
			MON: all,
			TUE: all,
			WED: all,
			THU: all,
			FRI: all,
			SAT: !all,
			SUN: !all
		});
	};

	const renderCheckbox = days.map((day: string) => {
		return (
			<Checkbox
				checked={ scheduledDay[ day as ScheduleDays ] }
				key={ day }
				onChange={ handleCheckboxChange(day, index) }
			>
				{ day }.
			</Checkbox>
		);
	});

	const popoverContent = (
		<div className="schedule-popover-content">
			<div className="schedule-popover-buttons">
				<Button ghost htmlType="button" onClick={ handleAllDayClick(true) }>Select All</Button>
				<Button ghost htmlType="button" onClick={ handleAllDayClick(false) }>Unselect All</Button>
				<Button ghost htmlType="button" onClick={ handleWeekdayClick(true) }>Weekday</Button>
				<Button ghost htmlType="button" onClick={ handleWeekdayClick(false) }>Weekend</Button>
			</div>
			<div className="schedule-popover-checkbox">
				{ renderCheckbox }
			</div>
		</div>
	);

	return (
		<Popover
			content={ popoverContent }
			trigger={ PopoverTrigger.CLICK }
			wrapClassName={ scheduleType === "weekly" ? "hidden" : "" }
		>
			<div className="table-icon-button" >
				<Icon name="pencil" size={ IconSize.SMALLER } />
			</div>
		</Popover>
	);
}

export default memo(SchedulePopover);
